import { filter as _filter } from 'lodash';

class NavbarController {
  constructor(authService, $state) {
    "ngInject";

    this.authService = authService;
    this.$state = $state;
  }

  logOut() {
    this.authService.logOut();
  }

  checkCustomPermission(item){
    if (item.name === 'Add Vehicle (Skupenet)') {
      return this.authService.hasEasierAd();
    }

    return true;
  }
}

export default NavbarController;



// WEBPACK FOOTER //
// ./client/app/common/navbar/navbar.controller.js